const home = {
  pickleballGlobal: "Pickleball's Most Accurate Global Rating System",
  freePlayers: 'Free for all Players',
  trustedByTheWorld:
    "Trusted by the world's premier Pickleball clubs, professional tours, and recreational players alike.",
  ourPhilosophy: 'Our Philosophy',
  innovateGame: 'Innovate the game.',
  unifySport: 'Unify the sport.',
  theMostAccurateGlobal:
    'The most accurate global rating system trusted by the world’s premier Pickleball clubs, tours, and professionals.',
  optimizedAccuracy: 'Optimized for Accuracy',
  yourDUPRRating: 'Your DUPR rating is calculated by',
  marginVictory: 'Margin of Victory',
  pointsWon: '(points won)',
  typeResult: 'Type of Result',
  recreationalEtc: '(recreational play vs. league, sanctioned tournaments, etc.)',
  outcome: 'Outcome',
  winLoss: '(win or loss)',
  builtPickleball: 'Built for the Pickleball Community',
  builtPickleballDesc:
    'A forward thinking, inclusive community deserves a rating to match. With DUPR, all players regardless of their age, gender, location, or skill are rated on the same scale between 2.00-8.00.',
  whatWeDo: 'What we do',
  aNewWayPlay: 'A New Way to Play',
  aNewWayPlayDesc:
    'The DUPR rating system does not lose out on any information or data. They incorporate everything into their algorithm, making it the most accurate',
  searchTheDatabase: 'Search the Database',
  searchTheDatabaseDesc: 'Browse the DUPR database of over 1,000,000 pickleball players.',
  findYourClub: 'Find your Club',
  findYourClubDesc: 'Follow your club to keep up to date with upcoming events.',
  analyzePerformance: 'Analyze your Performance',
  analyzePerformanceDesc: 'Track your progress as DUPR analyzes your play.',
  logMatches: 'Log Matches',
  logMatchesDesc: 'Enter scores from every match, any time.',
  connectLocalPlayers: 'Connect with Local Players',
  connectLocalPlayersDesc: 'Find local players and schedule play.',
  events: 'Events',
  eventsDesc: 'Test your skills against equal opponents in DUPR branded events.',
}

export type LocaleHome = typeof home

export default home
